export const RFM_SEGMENTS = [
  { key: 'champions', color: '#10b981' },
  { key: 'loyal', color: '#0ea5e9' },
  { key: 'potential_loyalists', color: '#3b82f6' },
  { key: 'new_customers', color: '#22d3ee' },
  { key: 'promising', color: '#a855f7' },
  { key: 'need_attention', color: '#eab308' },
  { key: 'at_risk', color: '#f97316' },
  { key: 'cant_lose', color: '#dc2626' },
  { key: 'hibernating', color: '#71717a' },
  { key: 'lost', color: '#52525b' },
  { key: 'prospects', color: '#94a3b8' },
];

export const RFM_SEGMENT_MAP = RFM_SEGMENTS.reduce((acc, s) => {
  acc[s.key] = s;
  return acc;
}, {});
